
import { AnalysisSection } from './types';
import { parseStringAnalysis, parseObjectAnalysis } from './analysisParser';

// Enhanced parsing function with better data structure handling
export const parseUltraDetailedAnalysis = (analysis: any): AnalysisSection[] => {
  console.log('🚀 Iniciando parseUltraDetailedAnalysis');
  console.log('📋 Dados de análise recebidos:', analysis);
  
  if (!analysis) {
    console.log('❌ Análise não fornecida');
    return [];
  }
  
  // Handle string format analysis
  if (typeof analysis === 'string') {
    console.log('📝 Processando análise em formato string');
    return parseStringAnalysis(analysis);
  }
  
  // Handle object format analysis
  console.log('📊 Processando análise em formato objeto');
  return parseObjectAnalysis(analysis);
};

export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
